import PropTypes from 'prop-types';
import { pivot } from '../../../data/mapsData';
import { formatNumberUsingUnit } from '../../../utils/formatUtils';

export const ZipCodePopupComponent = ({ area }) => {
  const getValue = (area, piv) => {
    if (area?.[piv?.value] === null) {
      return formatNumberUsingUnit(0);
    } else if (piv?.value === 'retail_status') {
      return formatNumberUsingUnit(area?.[piv?.value]);
    } else if (piv?.unit) {
      if (piv?.unit === '$') {
        return area?.[piv?.value] < 0
          ? formatNumberUsingUnit(area?.[piv?.value])
          : formatNumberUsingUnit(area?.[piv?.value], piv?.unit);
      } else {
        return formatNumberUsingUnit(area?.[piv?.value]?.toFixed(2), piv?.unit);
      }
    } else {
      return formatNumberUsingUnit(area?.[piv?.value]?.toFixed(2));
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '7px', fontWeight: 'bold' }}>Zip Code: {area?.zip_postal}</div>
      {pivot?.map((piv, _index) => (
        <div key={piv?.label} style={{ fontSize: '13px', marginBottom: '3px' }}>
          {`${piv?.label} : ${getValue(area, piv)}`}
        </div>
      ))}
    </div>
  );
};

ZipCodePopupComponent.propTypes = {
  area: PropTypes.shape({
    zip_postal: PropTypes.string,
    retail_status: PropTypes.string,
    owner_occupied_count: PropTypes.number,
    average_job_size: PropTypes.number,
    booked_appointments: PropTypes.number,
    close_rate: PropTypes.number,
    cancellation_rate: PropTypes.number,
    penetration_rate: PropTypes.number,
    tier_1_percentage: PropTypes.number,
    tier_2_percentage: PropTypes.number,
    tier_3_percentage: PropTypes.number,
    tier_4_percentage: PropTypes.number,
    opps: PropTypes.number,
    cumulative_1_2_3_percentage: PropTypes.number,
    color: PropTypes.string,
    coordinates: PropTypes.shape({
      type: PropTypes.string,
      geometry: PropTypes.shape({
        type: PropTypes.string,
        coordinates: PropTypes.oneOfType([
          PropTypes.arrayOf(PropTypes.number), // For point
          PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))), // For polygon
        ]),
      }),
    }),
  }).isRequired,
};
